import { Button, Container, Grid, Paper, Stack, Typography, Box, Dialog } from '@mui/material';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { toast, BASE_URL, request } from '../../../../../utils';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';


const validationSchema = Yup.object().shape({
  from_date: Yup.string().required('From date is required'),
  to_date: Yup.string().required('To date is required')
});

export const OtScheduleRegister = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  // const [patient, setPatient] = useState([])
  const [otName, setOtName] = useState([]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });
  const { watch } = methods;

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtention = '.xlsx';
    const respone = await axios.get(`${BASE_URL}/print/hospital/ot/ot-schedule-register?refId=${JSON.stringify({ from_date: watch('from_date'), to_date: watch('to_date'), uhid: watch('report') })}`)
    if (respone.data.success) {
      const filteredData = respone?.data?.data;
      if (filteredData.length > 0) {
        console.log("Condisnal Data", filteredData);
        const fileName = `Ot_Schedule_Reports_${watch('from_date')}_to_${watch('to_date')}`;

        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          'Schedule No.': item?.schedule_no,
          'Bill Date': formatDate(item?.date),
          'Patient Name': (`${item?.patientData?.name_suffix} ${item?.patientData?.first_name} ${item?.patientData?.last_name}`),
          'UHID  No.': item?.uhid,
          'Guardian Name': item?.patientData?.guardian_name,
          'Surgery Name': item?.serviceMasterData?.service_name,
          'Operation Theatre': item?.otTheatreData?.operationtheatre,
          'Ot Schedule Status': item?.status,
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtention);
      } else {
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };

  const fetchOtScheduleData = async () => {
    const response = await request('/operation-theatre-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOtName({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOtName({ loading: false });
    }
  };
  useEffect(() => {
    fetchOtScheduleData()
  }, [])

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Operation Theatre Schedule Register
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('report')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({
                        from_date: watch('from_date'),
                        to_date: watch('to_date'),
                        uhid: watch('report')
                      })}`,
                      '_blank'
                    )
                  }
                >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('report')}
                  onClick={handleExcelReport}
                >
                  Download Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>

            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%', boxShadow: '0px 2px 10px #0099ff' }}>
              <Grid container spacing={2}>
                <Grid item xs={10} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>OT Name</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="report"
                      menus={[{ name: 'All', _id: 'all' },
                      ...(Array.isArray(otName?.data) ? otName?.data?.map((data) => ({
                        ...data, name: data?.operationtheatre, _id: data?._id
                      })) : [])
                      ]}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
